__turbopack_context__.v({
  "error": "LabelContainer-module-scss-module__ASeCRW__error",
  "text": "LabelContainer-module-scss-module__ASeCRW__text",
});
